
import { List, Datagrid, TextField, DateField, NumberField } from 'react-admin';

export const Tbl_partitaList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <NumberField source="id" />
            <NumberField source="teamCasaId" />
            <NumberField source="teamOspiteId" />
            <NumberField source="legaStagioneId" />
            <NumberField source="legaId" />
            <NumberField source="stagioneId" />
            <DateField source="data" />
            <DateField source="ore" />
            <TextField source="luogo" />
            <TextField source="note" />
            <NumberField source="flVisibile" />
            <NumberField source="flAttivo" />
            <NumberField source="flAnnullato" />
            <NumberField source="ordinamento" />
            <DateField source="createdAt" />
            <DateField source="updatedAt" />
        </Datagrid>
    </List>
);
            